import { Badge, IconButton, makeStyles } from "@material-ui/core"
import { ErrorBoundary, IconAlertas } from "@portal/arq-portal-core"
import React from "react"
import { AlertasButton } from "./AlertasButton"

const useStyles = makeStyles(() => ({
    disabledIcon: {
        '& .MuiBadge-colorSecondary':{
            color: '#ffffffa8',
            backgroundColor: '#606060a1'
        }
    },
  }))

export const WrappedAlertasButton = (props:any) => { 
    const classes = useStyles(props);

    return (
        <ErrorBoundary 
            fallback={()=>{
                return <IconButton className={classes.disabledIcon} disabled aria-label="Alertas">
                    <Badge color="secondary" badgeContent={'X'}>
                        <IconAlertas style={{color: '#ffffffa8'}}></IconAlertas>
                    </Badge>
             </IconButton>
            }}
        >
                <AlertasButton {...props} />
        </ErrorBoundary>
    )
}